// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from './index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const main_page = {
    route_name: "converters",
    name: "翻譯本列表"
};
const new_page = {
    route_name: "new_converter",
    name: "新增翻譯本"
};
const edit_page = {
    route_name: "edit_converter",
    name: "編輯翻譯本"
};

const router = [
    {
        path: '',
        component: Index,
        name: 'converters',
        meta: {
            breadcrumb: [main_page]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_converter',
        meta: {
            breadcrumb: [main_page, new_page]
        }
    },
    {
        path: ':id/edit',
        component: Edit,
        name: 'edit_converter',
        meta: {
            breadcrumb: [main_page, edit_page]
        }
    },
]

export default router;
